import { render } from "./IVkLike.vue?vue&type=template&id=5978f06a"
import script from "./IVkLike.vue?vue&type=script&lang=js"
export * from "./IVkLike.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__